var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBubbleChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17141 7.27326C4.76995 6.8718 4.11906 6.8718 3.7176 7.27326C3.31614 7.67472 3.31614 8.32562 3.7176 8.72708C4.11906 9.12854 4.76995 9.12854 5.17141 8.72708C5.57287 8.32562 5.57287 7.67472 5.17141 7.27326ZM6.23207 6.2126C5.24483 5.22536 3.64419 5.22536 2.65694 6.2126C1.66969 7.19985 1.66969 8.80049 2.65694 9.78774C3.64419 10.775 5.24483 10.775 6.23207 9.78774C7.21932 8.80049 7.21932 7.19985 6.23207 6.2126Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2823 3.71784C11.8808 3.31638 11.2299 3.31638 10.8284 3.71784C10.427 4.1193 10.427 4.7702 10.8284 5.17166C11.2299 5.57312 11.8808 5.57312 12.2823 5.17166C12.6837 4.7702 12.6837 4.1193 12.2823 3.71784ZM13.3429 2.65718C12.3557 1.66994 10.755 1.66994 9.76778 2.65718C8.78053 3.64443 8.78053 5.24507 9.76778 6.23232C10.755 7.21956 12.3557 7.21956 13.3429 6.23232C14.3302 5.24507 14.3302 3.64443 13.3429 2.65718Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2823 10.8284C11.8808 10.427 11.2299 10.427 10.8284 10.8284C10.427 11.2299 10.427 11.8808 10.8284 12.2823C11.2299 12.6837 11.8808 12.6837 12.2823 12.2823C12.6837 11.8808 12.6837 11.2299 12.2823 10.8284ZM13.3429 9.76778C12.3557 8.78053 10.755 8.78053 9.76778 9.76778C8.78053 10.755 8.78053 12.3557 9.76778 13.3429C10.755 14.3302 12.3557 14.3302 13.3429 13.3429C14.3302 12.3557 14.3302 10.755 13.3429 9.76778Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.644 4.89791C10.8293 5.26839 10.6791 5.7189 10.3086 5.90414L6.36194 7.87747C5.99146 8.06271 5.54095 7.91255 5.35571 7.54206C5.17047 7.17158 5.32064 6.72107 5.69112 6.53583L9.63779 4.5625C10.0083 4.37726 10.4588 4.52742 10.644 4.89791Z",
    className: "icon-fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35571 8.45797C5.54095 8.08748 5.99146 7.93731 6.36194 8.12256L10.3086 10.0959C10.6791 10.2811 10.8293 10.7316 10.644 11.1021C10.4588 11.4726 10.0083 11.6228 9.63779 11.4375L5.69112 9.4642C5.32064 9.27896 5.17047 8.82845 5.35571 8.45797Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBubbleChart);
export default __webpack_public_path__ + "static/media/icon-bubble-chart.5684b089c8121edb18617f6d72910bdf.svg";
export { ForwardRef as ReactComponent };